require('./bootstrap');
require('select2');
require('startbootstrap-sb-admin-2/js/sb-admin-2.js');
require('datatables.net/js/jquery.dataTables.js');
require('datatables.net-dt');
require('datatables.net-bs4');
require('datatables.net-responsive');
require('datatables.net-responsive-bs4');
require('jszip/dist/jszip.js');
require('datatables.net-buttons/js/dataTables.buttons.js');
require('datatables.net-buttons/js/buttons.print.js');
require('datatables.net-buttons/js/buttons.colVis.js');
require('datatables.net-buttons/js/buttons.flash.js');
require('datatables.net-buttons/js/buttons.html5.js');
require('datatables.net-plugins/sorting/absolute.js');
require('./input-validate');

$body = $("body");
$(document).on({
    ajaxStart: function() { $body.addClass("loading");    },
    ajaxStop: function() { 
        setTimeout(function() {
        $body.removeClass("loading"); 
        }, 500);
        setTimeout(function(){
            $("div.alert").animate({
                    opacity: 0, // animate slideUp
                    marginRight: '-200px'
                }, 
                'slow', 'linear', function() {
                    $(this).remove();
            });
        }, 5000 );
    }
});

//Disable enter
$(document).ready(function() {
    $(window).keydown(function(event){
        if(event.keyCode == 13) {
            event.preventDefault();
            return false;
        }
    });
});

window.resetSoldOut = (type ,url) => {
    if (confirm('Are you sure you want to reset sold out status for all ' + type.toLowerCase() + ' items?')) {
        $.post(url, {
            _token: $('meta[name="csrf-token"]').attr('content')
        }).done(function(data) {
            showAlertMessage(data.message, data.success ? 'success' : 'error');
            location.reload();
        });
    }
}

window.clearExcludedStores = (type, url) => {
    if (confirm('Are you sure you want to clear all excluded stores for all ' + type.toLowerCase() + ' items?')) {
        $.post(url, {
            _token: $('meta[name="csrf-token"]').attr('content')
        }).done(function(data) {
            showAlertMessage(data.message, data.success ? 'success' : 'error');
            location.reload();
        });
    }
}

$(function() {
    /* select2-multiple2  */
    $.fn.select2.amd.require([
        'select2/selection/single',
        'select2/selection/placeholder',
        'select2/selection/allowClear',
        'select2/dropdown',
        'select2/dropdown/search',
        'select2/dropdown/attachBody',
        'select2/utils',
    ], function (SingleSelection, Placeholder, AllowClear, Dropdown, Search, AttachBody, Utils){

        var SelectionAdapter = Utils.Decorate(
            SingleSelection,
            Placeholder
        );
        
        SelectionAdapter = Utils.Decorate(
            SelectionAdapter,
            AllowClear
        );
          
        var DropdownAdapter = Utils.Decorate(
            Utils.Decorate(
                Dropdown,
                Search,
            ),
            AttachBody
        );
    
        var base_element = $('.select2-multiple2');
        $(base_element).select2({
            placeholder: 'Select multiple items',
            selectionAdapter: SelectionAdapter,
            dropdownAdapter: DropdownAdapter,
            allowClear: true,
            templateResult: function (data) {
                if (!data.id) { return data.text; }
                var $res = $('<div></div>');
                $res.text(data.text);
                $res.addClass('wrap');
                return $res;
            },
            templateSelection: function (data) {
                if (!data.id) { return data.text; }
                var selectAllOption = $('.select2-multiple2 option[value=0]:selected');
                if( data.id == '0' && data.selected == true  ){
                    data.selected = false;
                    $('.select2-multiple2 option').prop('selected',true);
                    $($('.select2-results__option')[0]).removeAttr('aria-selected');
                    $($('.select2-results__option')[0]).attr('aria-disabled', "true");
                }else if( data.id == '0' && data.selected == false ){
                    $('.select2-multiple2 option[value=0]').prop('selected',false);
                    $($('.select2-results__option')[0]).attr('aria-disabled', "false");
                    $($('.select2-results__option')[0]).attr('aria-selected', "false");
                    data.selected = true;
                }
                var selected = ($(base_element).val() || []).length;
                var total = $('option', $(base_element)).length;
                return "Selected " + selected + " of " + total;
            },
            sorter: function(data) {
                return data.sort(function(a, b) {
                    return a.id < b.id ? -1 : a.id > b.id ? 1 : 0;
                });
            }
        });
    });

    /* close alert message after 5 second */
    setTimeout(function(){
       $("div.alert").addClass('is-active');
    }, 500 );

    setTimeout(function(){
       $("div.alert:not(.alert-active)").addClass('is-active').remove();
    }, 5000 );
    
    $("input:file").change(function() {
        readURL(this);
    });

    $("button.remove-image").click(function(e) {
        e.preventDefault();
        removeUpload(this);
    });

    function readURL(input) {
        if (input.files && input.files[0]) {
            var reader = new FileReader();
            reader.onload = function(e) {
                $(input).parent('.image-upload-wrap').hide();
                $(input).parent('.image-upload-wrap').parent().removeClass('invalid-field');
                $(input).parent().next().children('.file-upload-image').attr('src', e.target.result);
                $(input).parent().next('.file-upload-content').addClass('d-flex');
                $(input).parents('form').find('button[type=submit]').removeAttr('disabled');
            };
            reader.readAsDataURL(input.files[0]);
        } else {
            removeUpload();
        }
    }

    function removeUpload(input) {
        var fileInput = $(input).parent().parent().prev('.image-upload-wrap').children('.file-upload-input');
        var fileIputId = $(fileInput).attr('id');
        var existing_image = $(input).parent().parent().prev('.image-upload-wrap').children('.existing-image');
        $(input).parent().parent().children('.file-upload-image').attr('src', '#');
        $(input).parent().parent().removeClass('d-flex');
        $(input).parent().parent().prev('.image-upload-wrap').show();
        $(fileInput).val(''); // reset file input
        $(existing_image).val('').attr('disabled', 'disabled');
        $(`#${fileIputId}_remove`).val('yes');
        if( !$(fileInput).hasClass("not_validate") ){
            $(input).parent().parent().prev('.image-upload-wrap').addClass('is-invalid');
            $(input).parent().parent().parent().addClass('invalid-field');
            if( $(input).parent().parent().prev('.image-upload-wrap').hasClass('is-invalid') ){
                $(input).parents('form').find('button[type=submit]').attr('disabled', 'disabled');
            }else{
                $(input).parents('form').find('button[type=submit]').removeAttr('disabled');
            }
        }
    }

    /* custom multiple select box start */
    $('body').on("change paste keyup", '.custom-multiple-select-box .filter-option-input', function(e){
        var filter = ($(this).val()).toUpperCase();
        var options = $(this).parent().parent().children('select').children('option');
        for (i = 0; i < options.length; i++) {
            txtValue = $(options[i]).text();
            if (txtValue.toUpperCase().indexOf(filter) > -1) {
                $(options[i]).removeClass('d-none');
            } else {
                $(options[i]).addClass('d-none');
            }
        }
        var option_show_length = $(this).parent().parent().children('select').children('option:not(.d-none)').length;
        $(this).parent().parent().children('.show-all-message').children('.count_options').html(option_show_length);
    });

    function sortingOption(element, child_element){
        var listitems = $(element).children(child_element).get();
        listitems.sort(function(a, b){
            return b.outerText.toUpperCase().localeCompare(a.outerText.toUpperCase());
        });
        $.each(listitems, function(index, item) {
           $(element).prepend(item); 
        });
    }

    $('body').on("click", '.select-all-button, .selected-list-button', function(e){
        e.preventDefault();
        var filter = $(this).parent().parent().children('.search-bar').children('input');
        var selectbox = $(this).parent().parent().children('select');
        var options = $(this).hasClass('selected-list-button') ? selectbox.children('option:not(.d-none):selected') : selectbox.children('option:not(.d-none)');

        var selectbox_id = $(selectbox).hasClass('left_select_box') ? ($(selectbox).attr('id')).replace("all_", "") : $(selectbox).attr('id');

        var selected_options = JSON.parse($(`#selected_${selectbox_id}_list`).val());
        var all_options = JSON.parse($(`#all_${selectbox_id}_list`).val());

        if( $(selectbox).hasClass('left_select_box') ){
            for (i = 0; i < options.length; i++) {
                var current_option = Number.isInteger($(options[i]).val()) ? ($(options[i]).val()).toString() : $(options[i]).val();
                var index_option = all_options.indexOf(current_option);
                if( !selected_options.includes(current_option) ){
                    $(`#${selectbox_id}`).append(`
                        <option value="`+current_option+`">
                            `+$(options[i]).text()+`
                        </option>
                    `);
                    if (index_option > -1) {
                        all_options.splice(index_option, 1);
                    }
                    $(options[i]).remove();
                    selected_options.push(current_option);
                }
            }
            sortingOption(`#${selectbox_id}`, 'option');
            $(`#${selectbox_id}`).parent().children('.show-all-message').children('.count_options').html(selected_options.length);
        }else if( $(selectbox).hasClass('right_select_box') ){
            for (i = 0; i < options.length; i++) {
                var current_option = Number.isInteger($(options[i]).val()) ? ($(options[i]).val()).toString() : $(options[i]).val();
                var index_option = selected_options.indexOf(current_option);
                if( !all_options.includes(current_option) ){
                    $(`#all_${selectbox_id}`).append(`
                        <option value="`+current_option+`">
                            `+$(options[i]).text()+`
                        </option>
                    `);
                    if (index_option > -1) {
                        selected_options.splice(index_option, 1);
                    }
                    $(options[i]).remove();
                    all_options.push(current_option);
                }
            }
            sortingOption(`#all_${selectbox_id}`, 'option');
            $(`#all_${selectbox_id}`).parent().children('.show-all-message').children('.count_options').html(all_options.length);
        }

        $(filter).val('').change();
        $(`#selected_${selectbox_id}_list`).val(JSON.stringify(selected_options));
        $(`#all_${selectbox_id}_list`).val(JSON.stringify(all_options));
    });
    /* custom multiple select box end */
});
window.stopPropagation = function(evt) {
    if (evt.stopPropagation !== undefined) {
        evt.preventDefault();
        evt.stopPropagation();
    } else {
        evt.cancelBubble = true;
    }
}